import React, { Fragment } from "react";
import {
  List,
  Datagrid,
  Filter,
  TextInput,
  TextField,
  EditButton,
} from "react-admin";
import useCheckPermissions from '../AdminPermissions/useCheckPermissions'


const ListFilter = (props) => (
  <Filter {...props}>
    <TextInput label="Search" source="q" alwaysOn />
   
  </Filter>
);

const AddonandVideoTaskLabelList = ({ ...props }) => {
  return (
    <List
      {...props}
      title="Labels"
     
      filters={<ListFilter />}
     
    >
      <Datagrid rowClick={"show"}>
      <TextField source="id" />
            <TextField source="label1" label="Label1" />
            <TextField source="label2" label="Label2" />
            <TextField source="label3" label="Label3" />
            <TextField source="label4" label="Label4" />
            <TextField source="label5" label="Label5" />
            <TextField source="label6" label="Label6" />
            <TextField source="label7" label="Label7" />
            <TextField source="label8" label="Label8" />
            <TextField source="label9" label="Label9" />
            <TextField source="label10" label="Label10" />
            <TextField source="label11" label="Label11" />
            <TextField source="label12" label="Label12" />
            <TextField source="label13" label="Label13" />
            <TextField source="label14" label="Label14" />
            <TextField source="label15" label="Label15" />
            <TextField source="task_type" label="Task Type" />
             <TextField source="type" label="Type" />
             <TextField source="label_id" label="label Id" />


        {useCheckPermissions('AddonandVideoTaskLabel_Edit')?<EditButton />:null}
      </Datagrid>
    </List>
  );
};

export default AddonandVideoTaskLabelList;
